import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { MENU } from '../../views/layout/sidebar/menu';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor() {}

  // units = ['Kilogram', 'Gram', 'Liter', 'Milliliter', 'Pieces', 'Portion', "Packets"];
  units = [];

  outlets: any[];

  version = '5.12';
  frontEndDomain = environment.frontendDomain;

  userDetails: any = [];

  selectedOutlet: string | number;
  userPermissions: any[] = [];

  permissions = [
    {
      feature_id: 1,
      name: 'purchase-order',
    },
    {
      feature_id: 2,
      name: 'bills',
    },
    {
      feature_id: 3,
      name: 'sale-order',
    },

    // {
    //   feature_id: 4,
    //   name: 'sale-order-invoice',
    // }
    {
      feature_id: 5,
      name: 'contacts',
    },

    {
      feature_id: 6,
      name: 'products',
    },

    {
      feature_id: 7,
      name: 'planning', //not working
    },
    ,
    {
      feature_id: 8,
      name: 'reports',
    },

    {
      feature_id: 9,
      name: 'templates', //not working
    },
    ,
    {
      feature_id: 10,
      name: 'log', //not working (inventory log)
    },

    {
      feature_id: 11,
      name: 'close', //not working (closing inventory)
    },

    {
      feature_id: 12,
      name: 'wastage', //not working (wastage inventory)
    },

    {
      feature_id: 13,
      name: 'wastage-recipe', //not working  staff-consumption
    },

    {
      feature_id: 14,
      name: 'staff-consumption', //not working (staff-consumption )
    },
    {
      feature_id: 15,
      name: 'dashboard',
    },
  ];

  disableSidenavByPermissions() {
    // purchase order
    let userPermission = this.userPermissions.find(
      (permission) =>
        permission.feature_id == 1 &&
        permission.outlet_id == this.selectedOutlet
    );
    if (userPermission) {
      if (userPermission.create == 1 || userPermission.view == 1) {
        MENU[2].disabled = false;
      } else {
        MENU[2].disabled = true;
      }
    }
  }

  getSelectedOutletIds() {
    if (this.selectedOutlet == 0) {
      return this.outlets
        .filter((outlet) => outlet.id != 0)
        .map((outlet) => outlet.id);
    } else {
      return this.outlets
        .filter((outlet) => outlet.id == this.selectedOutlet)
        .map((outlet) => outlet.id);
    }
  }

  isAdminOutlet() {
    return this.selectedOutlet == 0;
  }

  isUserAdmin() {
    return this.userDetails.is_admin == 1;
  }

  checkPermissions(dataService: any, feature_id: any) {
    let tempPermissions = dataService.userPermissions.filter(
      (ele: any) =>
        ele.feature_id == feature_id &&
        ele.outlet_id == dataService.selectedOutlet
    );
    let permissions;

    if (
      dataService.selectedOutlet == 0 ||
      dataService.userDetails.is_admin == 1
    ) {
      permissions = {
        create: 1,
        view: 1,
        update: 1,
        delete: 1,
      };
    } else {
      permissions = tempPermissions.length
        ? { ...tempPermissions[0] }
        : { ...dataService.defaultPermissions };
    }

    return permissions;
  }

  defaultPermissions = {
    view: 0,
    create: 0,
    update: 0,
    delete: 0,
    auto_approve: 0,
  };

  clearData() {
    this.userDetails = [];
    this.selectedOutlet = '';
    this.userPermissions = [];
    this.outlets = [];
  }
}

// feature list = [
//   {
//       "name": "Purchase Orders",
//   },
//   {
//       "name": "Purchase Order Bills",
//   },
//   {
//       "name": "Sales Orders",
//   },
//   {
//       "name": "Sales Order Invoices",
//   },
//   {
//       "name": "Contacts",
//   },
//   {
//       "name": "Products",
//   },
//   {
//       "name": "Planning",
//   },
//   {
//       "name": "Reports",
//   },
//   {
//       "name": "Templates",
//   },
//   {
//       "name": "Inventory Overview",
//   },
//   {
//       "name": "Closing Inventory",
//   },
//   {
//       "name": "Wastage Inventory",
//   },
//   {
//       "name": "Recipe Wastage Inventory",
//   },
//   {
//       "name": "Staff Consumption",
//   }
// ]
